const finasterides = [
  '프로스카정',
  '프로페시아정',
  '피나스타정',
  '알파스카정',
  '프로피나정',
  '프로스몰정',
  '피나이스정',
  '한올피나스테리드정',
  '스카렉스정',
  '피나로신정',
  '피나드론정',
  '스카테론정',
  '유로리드정',
  '프로엠정',
  '대웅바이오피나스테리드정',
  '핀카정',
  '유로피나정',
  '피나베린정',
  '피로이드정',
  '푸로스타정',
  '프로리드정',
  '피나스텔정',
  '피나스티드정',
  '파나스카정',
  '리드페시아정',
  '트로피나정',
  '파나드정',
  '보령피나스테리드정',
  '일양피나스테리드정',
  '유로스칸정',
  '피스테리정',
  '푸로케어정',
  '피나테드정',
  '파세드정',
  '한림피나스테리드정',
  '알로시아정',
  '피나스틴정',
  '모나스타정',
  '알로페시드정',
  '헤어페시아정',
  '헤어피나정',
  '피나모린정',
  '레나시딘정',
  '바로피나정',
  '발트만정',
  '미노페시아정',
  '네오페시아정',
  '마이시아정',
  '다모케어정',
  '메디페시아정',
  '알로게인정',
  '그로모정',
  '모나리드정',
  '모나스틴정',
  '두피나정',
  '피나페시아정',
  '케이시아정',
  '피나시딜정',
  '모나드정',
  '헤나모정',
  '페로시아정',
  '헤어게인정',
  '다모페시아정',
  '헤어스모정',
  '알로펙정',
  '알로스칸정',
  '뉴피나정',
  '마이페시아정',
  '하이페시아정',
  '베아리모정',
  '프로시정',
  '마인페시아정',
  '헤어그로정',
  '유나피아정',
  '유나시아정',
  '모나필정',
  '피나젠정',
  '프리스타정',
  '피나트라정',
  '핀스타정',
  '피나라이드정',
  '화이자피나스테리드정',
  '피나세틴정',
  '필라스트정',
  '나우스카정',
  '프리피나정',
  '파나리드정',
  '프로스테리드정',
  '피나시아정',
  '피나그렌정',
  '피나린정',
  '프로스타트정',
  '마이피나정',
  '메리나정',
  '피나프로스정',
  '피나텐정',
  '피나스토정',
  '에피나시정',
  '씨엠피나정',
  '씨엠프로정',
  '피나스칸정',
  '피나드정',
  '피나정',
  '모나정',
  '모더페시아정',
  '비피케어정',
  '피나스로정',
  '티나제정',
  '프로스틸정',
  '모페시아정',
  '베르모나정',
  '엔피스카정',
  '피나스테아정',
  '피나진정',
  '피테스정',
  '피나롤정',
  '프로나드정',
  '하이피나정',
  '유레이드정',
  '피나에이블정',
  '비보존피나스테리드정',
  '피나즈정',
  '알로피나정',
  '피나론정',
  '모나페시아정',
  '스텐카정',
  '이노엔피나스테리드정',
  '삼성피나스테리드정',
  '피나스트리온정',
  '모나시아정',
  '큐로이드정',
  '프로화정',
  '모리턴정',
  '신신피나스테리드정',
  '피나스정',
  '피나윈정',
  '리모날정',
  '엔피나정',
  '다림피나스테리드정',
  '모어에이블정',
  '피나스톤정',
  '피나테크정',
  '피나스테린정',
  '피나세타정',
  '유니테리드정',
  '모그로정',
  '프로모아정',
  '피노테정',
  '알파엠정',
  '포뮬레시아정',
  '제이페시아정',
  '제이피나정',
  '모모페시아정',
  '피나리정',
  '피나디드정',
  '에이페시아정',
  '피나프로정',
  '뉴리드정',
  '위피나정',
  '멕스페시아정',
  '피나온정',
  '피나세트정',
  '테라피나스정',
  '명문피나스테리드정',
  '뉴페시아정',
  '피나에스정',
  '피나모아정',
  '프로핀카정',
  '한국팜비오피나스테리드정',
  '피나스트정',
  '아스테리정',
  '헤오나정',
  '피나앤정',
  '휴피나정',
  '피나신정',
  '텔콘알에프피나스테리드정',
  '스테리정',
  '프로아모정',
  '다모테리드정',
  '비피스타정',
  '메가페시아정',
  '엔티테리드정',
  '피나스텐정',
  '소피나정',
  '피나시드정',
  '안국피나스테리드정',
  '뉴모나스테리드정',
  '모벤시아정',
  '모모드정',
  '피나엠정',
  '다나페시아정',
  '모시아모정',
  '알로테드정',
  '와이투피나정',
  '그로페시아정',
  '피나모정',
  '제노페시아정',
  '오뉴페시아정',
  '원페시아정',
];

const liraglutides = ['빅토자펜주', '삭센다펜주', '줄토피플렉스터치주'];

const isotretinoins = [
  '아키놀연질캡슐',
  '니메겐연질캡슐',
  '핀플연질캡슐',
  '이소틴연질캡슐',
  '뉴티논연질캡슐',
  '이소티나연질캡슐',
  '이소트렌연질캡슐',
  '아크날연질캡슐',
  '트레틴연질캡슐',
  '아큐네탄연질캡슐',
  '이소티논연질캡슐',
  '이소트레틴겔',
  '레씨범연질캡슐',
  '트레인연질캡슐',
  '제로큐탄연질캡슐',
  '로아큐탄캡슐',
  '트레논연질캡슐',
  '로이탄연질캡슐',
  '오피큐탄연질캡슐',
  '아크논연질캡슐',
  '이소탐연질캡슐',
  '우리큐탄연질캡슐',
  '클레어연질캡슐',
  '삼성이소트레티노인연질캡슐',
  '이소팩트연질캡슐',
  '로아크연질캡슐',
  '화이트이소트레티노인연질캡슐',
  '로큐탄연질캡슐',
  '레아큐연질캡슐',
  '안국이소트레티노인연질캡슐',
  '모아큐탄연질캡슐',
];

const clindamycins = [
  '듀케이겔',
  '에피외용액',
  '아클리신액',
  '아크닌액',
  '다크린외용액',
  '크리신외용액',
  '듀오크린액',
  '아크프리외용액',
  '크레오신티외용액1％',
  '퓨어킨외용액',
  '아크네신액',
  '클린티외용액',
  '에이치피앤씨클린다마이신포스페이트외용액1%',
  '클린다-케이외용액',
  '클린디올액',
  '끌로이외용액',
  '클린다미액',
  '피에이큐라덤외용액',
  '동인에피겔',
  '진다클린겔',
  '큐티안겔',
  '클린디올겔',
  '크레오신질크림2%',
  '듀악겔',
  '듀악겔5%',
  '듀악겔3%',
  '클리스코주',
  '크레오신주',
  '클리마이신주',
  '훌그램주사',
];

const dutasterides: string[] = [
  '아보다트연질캡슐',
  '유힐릭스연질캡슐',
  '두타반연질캡슐',
  '두타론연질캡슐',
  '두테스몰연질캡슐',
  '아보스타연질캡슐',
  '아보테리드연질캡슐',
  '아나딘연질캡슐',
  '네오다트연질캡슐',
  '두테드연질캡슐',
  '씨엠두타연질캡슐',
  '두타리드연질캡슐',
  '아보피나연질캡슐',
  '두타텍트연질캡슐',
  '두아보연질캡슐',
  '아보스티드연질캡슐',
  '두타라이드연질캡슐',
  '두타스카연질캡슐',
  '아두타연질캡슐',
  '아보테드연질캡슐',
  '두타렉스연질캡슐',
  '원투스테리드연질캡슐',
  '두로칸연질캡슐',
  '두타젠연질캡슐',
  '아보두타연질캡슐',
  '다모다트연질캡슐',
  '아보타스연질캡슐',
  '아보탄연질캡슐',
  '두타드연질캡슐',
  '휴메리나연질캡슐',
  '두타겟연질캡슐',
  '두테론연질캡슐',
  '대웅바이오두타스테리드연질캡슐',
  '삼천당두타스테리드연질캡슐',
  '자이가드연질캡슐',
  '프로다트연질캡슐',
  '두타락연질캡슐',
  '안국두타스테리드연질캡슐',
  '유로다트연질캡슐',
  '타테린연질캡슐',
  '아다모연질캡슐',
  '두타케어정',
  '제이다트정',
  '두타반플러스정',
  '네오다트정',
  '엔피다트정',
  '두로케어정',
  '두아모정',
  '아보그로정',
  '두테스정',
  '대웅바이오두타스테리드정',
  '원투스테리드정',
  '두타론정',
  '다모다트정',
  '두타리드정',
  '두타브정',
  '아보타스정',
  '아보투윈연질캡슐',
  '에이두타정',
  '듀타그렌정',
  '두타스테린정',
  '아이두타연질캡슐',
  '두타온연질캡슐',
  '중헌두타스테리드연질캡슐',
  '두타그로연질캡슐',
  '아보다칸정',
  '두테론정',
  '모모타정',
  '두타윈연질캡슐',
  '두타스텐정',
  '두타모아정',
  '두타스타정',
  '보령두타스테리드연질캡슐',
  '팜젠두타스테리드연질캡슐',
  '아리드정',
  '두타엘정',
  '아다모정',
  '아보테드정',
  '두타린정',
  '삼성두타스테리드정',
  '아보리드정',
  '두리드정',
  '두타베린정',
  '두다트정',
  '케이두타다트정',
  '일성두타스테리드정',
  '두타겟정',
  '메가두타연질캡슐',
  '두타프렌정',
  '두보트정',
  '두타엠연질캡슐',
  '삼천당두타스테리드정',
  '두타시드정',
  '두타엠정',
  '두로칸정',
  '머카나정',
  '휴메리나정',
  '안국두타연질캡슐',
  '두모보연질캡슐',
  '아보텍트정',
  '두타모정',
  '모모다트정',
  '휴다트연질캡슐',
  '두리스연질캡슐',
  '동구두타리드연질캡슐',
  '아보엠연질캡슐',
  '모벤두타정',
  '에이두타연질캡슐',
];

const semaglutides = ['위고비프리필드펜', '오젬픽프리필드펜', '리벨서스정'];

export const PHARMACY_MEDICINE_NAMES_MAP: Record<string, { medicineList: string[]; name: string }[]> = {
  '9': [
    { medicineList: finasterides, name: '피나스테리드' },
    { medicineList: dutasterides, name: '두타스테리드' },
  ],
  '12': [
    { medicineList: liraglutides, name: '리라글루티드' },
    { medicineList: semaglutides, name: '세마글루티드' },
  ],
  '11': [
    { medicineList: isotretinoins, name: '이소트레티노인' },
    { medicineList: clindamycins, name: '클린다마이신' },
  ],
};
